'use strict';

module.exports = {
    common: {
        fontsLoaded: 'fonts-loaded',
        scrollTop: 'scroll-top',
        splashBackgroundChange: 'splash-background-change',
        pageLoaded: 'page-loaded',
        sequenceImagesLoaded: 'sequence-images-loaded',
        scroll: 'on-scroll',
        resize: 'on-resize',
        resizeStarted:  'resize-started',
        resizeEnded: 'resize-ended'
    },

    canvid: {
        sequenceLoaded: 'sequence-loaded'
    },

    home: {
        hero: {
            sequenceStarted: 'sequence-started',
            sequenceHidded: 'sequence-hidded',
            sequenceEnded: 'sequence-ended',
            sequenceEntered: 'sequence-entered',
            cardLoaded: 'card-loaded',
            videoSequenceLoaded: 'home-hero-video-sequence-loaded'
        },
        tailored: {
            cardTransitionAfter: 'card-transition-after',
            cardTransitionBefore: 'card-transition-before',
            cardTransitionBottomDown: 'card-transition-bottom-down',
            cardTransitionBottomUp: 'card-transition-bottom-up',
            cardTransitionInProgress: 'card-transition-progress'
        },
        results: {
            cardResize: 'results-card-resize'
        }
    },


    popup: {
        popupOpen: 'popup-open',
        popupShown: 'popup-shown',
        popupHidden: 'popup-hidden',
        popupShow: 'popup-show'
    },

    videoPlayer: {
        openPlayer: 'video-player-open',
        youtubeApiReady: 'youtube-ready'
    }
};
